export default __webpack_public_path__ + "static/media/BugCatcherLogin.5443caf2.png";